/**
 * Navbar.js
 *
 * Responsive Apple-style glass navbar with real liquid-glass buttons.
 * - Full width on desktop
 * - Hamburger menu on mobile
 * - Clear glass blur and light reflections
 */

import React, { useState } from "react";
import { Link } from "react-router-dom";
import SignUpAndInModal from "../SignUp/SignUpAndInModal";
import ProfileButton from "../SignUp/ProfileButton";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur-2xl bg-transparent text-white">
                <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4">
                    {/* --- Logo --- */}
                    <div className="text-xl md:text-2xl font-semibold tracking-tight text-white cursor-pointer">
                        ISayYashToThat
                    </div>

                    {/* --- Desktop Links --- */}
                    <div className="hidden md:flex flex-row items-center space-x-6">
                        {["Home", "About", "Contact", "Games"].map((label, index) => (
                            <Link
                                key={index}
                                to={label === "Home" ? "/" : `/${label.toLowerCase()}`}
                                className="
                                    relative inline-flex items-center justify-center w-24
                                    px-4 py-2 text-sm font-medium text-white rounded-3xl
                                    bg-white/5 border border-white/40 backdrop-blur-md
                                    shadow-[inset_0_1px_0px_rgba(255,255,255,0.75),0_0_9px_rgba(0,0,0,0.2),0_3px_8px_rgba(0,0,0,0.15)]
                                    before:absolute before:inset-0 before:rounded-3xl
                                    before:bg-gradient-to-br before:from-white/60 before:via-transparent before:to-transparent
                                    before:opacity-70 before:pointer-events-none
                                    after:absolute after:inset-0 after:rounded-3xl
                                    after:bg-gradient-to-tl after:from-white/30 after:via-transparent after:to-transparent
                                    after:opacity-50 after:pointer-events-none
                                    hover:bg-white/20 transition-all duration-300
                                "
                            >
                                {label}
                            </Link>
                        ))}
                        <ProfileButton onOpenSignInModal={() => setShowModal(true)} />
                    </div>

                    {/* --- Hamburger (Mobile Only) --- */}
                    <button
                        className="md:hidden flex flex-col justify-center items-center space-y-1 focus:outline-none"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span
                            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                                isOpen ? "rotate-45 translate-y-1.5" : ""
                            }`}
                        ></span>
                        <span
                            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                                isOpen ? "opacity-0" : ""
                            }`}
                        ></span>
                        <span
                            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                                isOpen ? "-rotate-45 -translate-y-1.5" : ""
                            }`}
                        ></span>
                    </button>
                </div>

                {/* --- Mobile Dropdown --- */}
                <div
                    className={`md:hidden overflow-hidden transition-all duration-500 ${
                        isOpen ? "h-auto opacity-100" : "max-h-0 opacity-0"
                    }`}
                >
                    <ul className="flex flex-col items-center py-4 space-y-3 text-lg font-medium text-white bg-white/10 backdrop-blur-2xl border-t border-white/20">
                        {["Home", "About", "Contact", "Games"].map((label, index) => (
                            <li key={index}>
                                <Link
                                    to={label === "Home" ? "/" : `/${label.toLowerCase()}`}
                                    onClick={() => setIsOpen(false)}
                                    className="hover:text-zinc-300 transition-colors"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                        <ProfileButton onOpenSignInModal={() => setShowModal(true)} />
                    </ul>
                </div>
            </nav>
            <SignUpAndInModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
            />
        </>
    );
};

export default Navbar;